import React, {Children, ReactElement, useEffect, useState} from "react";
import {Box, Fade} from "@mui/material";

interface SvgCrossfadeProps {
    children: ReactElement[];
}

export const SvgCrossfade = ({ children }: SvgCrossfadeProps) => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % children.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [children.length]);

    return (
        // Full height of the container, so the stacked SVGs can fill it at `100%` and scale with it.
        // `Children.map` keys each `Fade` from its child, so the fixed set of SVGs keeps its identity across renders.
        <Box sx={{ position: "relative", height: "100%" }}>
            {Children.map(children, (Svg, i) => (
                <Fade in={index === i} timeout={1000}>
                    <Box sx={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}>{Svg}</Box>
                </Fade>
            ))}
        </Box>
    );
};
